import React from "react";

function Shipment({ colorCode = "" }) {
  return (
    <svg className="MuiSvgIcon-root" viewBox="0 0 22 28" fill={colorCode}>
      <path
        d="M15.029 12H6.97253C6.52055 12 6.15332 12.3672 6.15332 12.8192C6.15332 13.2712 6.52055 13.6384 6.97253 13.6384H15.029C15.481 13.6384 15.8482 13.2712 15.8482 12.8192C15.8482 12.3672 15.481 12 15.029 12Z"
        fill={colorCode}
        stroke={colorCode}
        strokeWidth="0.2"
      />
      <path
        d="M15.029 15.9561H6.97253C6.52055 15.9561 6.15332 16.3233 6.15332 16.7753C6.15332 17.2272 6.52055 17.5945 6.97253 17.5945H15.029C15.481 17.5945 15.8482 17.2272 15.8482 16.7753C15.8482 16.3233 15.481 15.9561 15.029 15.9561Z"
        fill={colorCode}
        stroke={colorCode}
        strokeWidth="0.2"
      />
      <path
        d="M15.029 19.9385H6.97253C6.52055 19.9385 6.15332 20.3057 6.15332 20.7577C6.15332 21.2097 6.52055 21.5769 6.97253 21.5769H15.029C15.481 21.5769 15.8482 21.2097 15.8482 20.7577C15.8482 20.3057 15.481 19.9385 15.029 19.9385Z"
        fill={colorCode}
        stroke={colorCode}
        strokeWidth="0.2"
      />
      <path
        d="M17.1582 4.67232H16.565V4.61582C16.565 3.59887 15.7458 2.77966 14.7288 2.77966H13.4859C13.1469 1.76271 12.1582 1 10.9718 1C9.84181 1 8.85311 1.73446 8.51412 2.77966H7.27119C6.25424 2.77966 5.43503 3.59887 5.43503 4.61582V4.67232H4.84181C2.72316 4.67232 1 6.39548 1 8.51412V24.0226C1 26.1412 2.72316 27.8644 4.84181 27.8644H17.1582C19.2768 27.8644 21 26.1412 21 24.0226V8.51412C21 6.39548 19.2768 4.67232 17.1582 4.67232ZM7.1017 4.61582C7.1017 4.50282 7.18644 4.41808 7.29944 4.41808H9.22034C9.67232 4.41808 10.0395 4.05085 10.0395 3.59887C10.0395 3.0904 10.4633 2.66667 11.0282 2.66667C11.5367 2.66667 11.9605 3.0904 11.9605 3.59887C11.9605 4.05085 12.3277 4.41808 12.7797 4.41808H14.7006C14.8136 4.41808 14.8983 4.50282 14.8983 4.61582V6.0565C14.8983 6.16949 14.8136 6.25424 14.7006 6.25424H7.29944C7.18644 6.25424 7.1017 6.16949 7.1017 6.0565V4.61582ZM19.3616 23.9944C19.3616 25.209 18.3729 26.1695 17.1864 26.1695H4.84181C3.62712 26.1695 2.66667 25.1808 2.66667 23.9944V8.51412C2.66667 7.29944 3.65537 6.33898 4.84181 6.33898H5.46328C5.60452 7.24294 6.36723 7.9209 7.29944 7.9209H14.7288C15.661 7.9209 16.4237 7.24294 16.565 6.33898H17.1864C18.4011 6.33898 19.3616 7.32768 19.3616 8.51412V23.9944Z"
        fill={colorCode}
        stroke={colorCode}
        strokeWidth="0.2"
      />
    </svg>
  );
}

export default Shipment;
